import "react-quill/dist/quill.snow.css";
import React from "react";
import { Card, Form, Button, Space, Alert, Typography } from "antd";
import ReactQuill from "react-quill";

import useUpdate from "hooks/useUpdate";

import useFormErrors from "hooks/useFormErrors";
import { useParams } from "react-router-dom";
import { useIssueKinds } from "context/providers/issue_kinds";
import QuestionMarkTooltip from "components/QuestionMarkTooltip";

const default_info = `
  <p>Na zgłoszenie serwisowe odpowiadamy do <strong>3h</strong> w dni robocze w godzinach <strong>8:00-16:00</strong> od momentu zarejestrowania w aplikacji.</p>
  <p>Potwierdzenie wysłania zgłoszenia serwisowego otrzymają Państwo na podany adres e-mail w formularzu.<br>Proszę czekać na wiadomość SMS z najbliższym terminem wizyty lub na połączenie telefoniczne w celu umówienia najbliższego terminu wizyty.</p> 
  <p>Podejmujemy 3 próby połączenia telefonicznego w ciągu dnia roboczego.</p>
  <p>Po nieudanych 3 próbach zgłoszenie serwisowe zostaje anulowane.</p>
`;

const Info = () => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const { data, refetch } = useIssueKinds();
  const issue_kind = data.find((item) => item.id === id);

  const path = `/issue_kinds/${id}`;
  const { is_saving, update } = useUpdate({
    path,
    form,
    onSuccess: refetch,
  });
  const { has_error, onFieldsChange } = useFormErrors();

  const info = issue_kind?.info || "";

  return (
    <Form
      className="m-b-20"
      form={form}
      layout="vertical"
      onFieldsChange={onFieldsChange}
      initialValues={{
        info,
      }}
      onFinish={(values) => update(values)}
    >
      {(values) => {
        const dirty = values.info !== info;
        const is_to_many_characters = (values.info?.length || 0) > 1000;

        return (
          <Card
            title={
              <>
                Opis informacyjny{" "}
                <QuestionMarkTooltip
                  text="Informacja wyświetlana na stronie formularza w niebieskim
                panelu."
                />
              </>
            }
            styles={{
              body: {
                padding: "10px 24px 0",
              },
            }}
            extra={
              <Button
                disabled={!dirty || has_error || is_to_many_characters}
                loading={is_saving}
                type="primary"
                htmlType="submit"
              >
                Zapisz
              </Button>
            }
          >
            {dirty && (
              <Alert
                message="UWAGA! Zapisz zmiany przed wyjściem!"
                banner
                style={{ marginBottom: 20 }}
              />
            )}
            <Form.Item
              name="info"
              rules={[
                () => ({
                  validator(_, value) {
                    const text = value.replace(/<[^>]*>/g, "");
                    const has_any_letter = /[a-zA-Z0-9]/.test(text);

                    if (text.length > 0 && !has_any_letter) {
                      return Promise.reject(
                        new Error("Pole tekstowe nie zawiera znaków.")
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <ReactQuill
                value={values.info}
                onChange={(val, _, __, { getLength }) => {
                  form.setFieldValue("info", getLength() > 1 ? val : "");
                }}
                modules={{
                  toolbar: [
                    ["bold", "italic"],
                    [{ list: "ordered" }, { list: "bullet" }],
                  ],
                }}
              />
              <p className="counter-info">
                <Typography.Text
                  type={is_to_many_characters ? "danger" : "secondary"}
                >
                  {values.info?.length || 0} / 1000
                </Typography.Text>
              </p>
            </Form.Item>
            <Space style={{ marginBottom: 20 }}>
              <Button
                type="primary"
                htmlType="button"
                size="small"
                onClick={() => {
                  form.setFieldValue("info", default_info);
                }}
              >
                Wypełnij przykładowym tekstem
              </Button>
              <Button
                type="primary"
                htmlType="button"
                size="small"
                onClick={() => {
                  form.setFieldValue("info", "");
                }}
              >
                Wyczysć tekst
              </Button>
            </Space>
          </Card>
        );
      }}
    </Form>
  );
};

export default Info;
